import { type ListVariant } from './types';

export const indicatorGaps: Record<ListVariant, number> = {
	rotation: 0,
	participant: 4,
};
